angular
    .module("showcaseApp")
    .component("selectProduct", {
        templateUrl: "app/components/select-product/select-product.html",
        scope: {},
        bindings: {
            labelKey: "@",
            model: "=",
            name: "@",
            required: "<",
            errors: "<",
            placeholder: "@",
            form: "<",
            onChange: "&",
            disabled: "<",
            readonly: "<",
            isImmo: "<"
        },
        controller: "SelectProductController",
    }).directive("changeItems", function () {
            return {
                restrict: "A",
                link: function (scope) {
                    scope.$watch("$ctrl.selectProduct", function (newValue) {
                        if (scope.$ctrl.onChange) {
                            scope.$ctrl.onChange({ newValue: newValue });
                        }
                    });
                },
            };
        });
